import checkSubmissionsReportForErrors from "~/store/manage/validation/checkSubmissionsReportForErrors";

const VALIDATE_FUNDER_REPORT = (state) => {
  state.fundersReportErrors = checkSubmissionsReportForErrors(state);
};

export default VALIDATE_FUNDER_REPORT;
